module.exports = __webpack_public_path__ + "static/media/contrato.3c5eeb70.svg";